import { z } from 'zod';

/** GET /api/v1/healthz — liveness only, carries no user data. */
export const HealthResponse = z.object({
  status: z.literal('ok'),
  version: z.string(),
});
export type HealthResponse = z.infer<typeof HealthResponse>;
